import { useGetState } from "components/ReduxProvider";
import { useViewerDecks } from "queries/viewerQuery";

export const useGetGrammar = (text: string) => {
  const cardsData = useGetState("idbCardsData");
  const { deck } = useViewerDecks();

  return cardsData && deck && cardsData.find((cd) => cd.text === text && cd.lang === deck.front)?.grammar;
};
